const IMPERSONATION_STORAGE_KEY = "mr_admin_impersonation";
const IMPERSONATION_EVENT = "mr-impersonation-changed";

type UserSnapshot = {
  user_id?: string;
  user_type?: string;
  email?: string;
  full_name?: string;
  [key: string]: unknown;
};

export type ImpersonationSession = {
  timestamp: string;
  adminUserId: string;
  targetUserId: string;
  adminToken: string;
  adminUser: UserSnapshot;
};

const emitImpersonationChanged = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(IMPERSONATION_EVENT));
};

export const getImpersonationEventName = () => IMPERSONATION_EVENT;

export const getImpersonationSession = (): ImpersonationSession | null => {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.adminToken || !parsed?.adminUserId || !parsed?.targetUserId) return null;
    return parsed as ImpersonationSession;
  } catch {
    return null;
  }
};

export const isImpersonating = (): boolean => {
  return Boolean(getImpersonationSession());
};

export const startImpersonationSession = (params: {
  adminToken: string;
  adminUser: UserSnapshot;
  adminUserId: string;
  targetUserId: string;
  impersonatedToken: string;
  impersonatedUser: UserSnapshot;
}) => {
  if (typeof window === "undefined") return;
  const session: ImpersonationSession = {
    timestamp: new Date().toISOString(),
    adminUserId: params.adminUserId,
    targetUserId: params.targetUserId,
    adminToken: params.adminToken,
    adminUser: params.adminUser
  };
  localStorage.setItem(IMPERSONATION_STORAGE_KEY, JSON.stringify(session));
  localStorage.setItem("token", params.impersonatedToken);
  localStorage.setItem("user", JSON.stringify(params.impersonatedUser));
  emitImpersonationChanged();
};

export const clearImpersonationSession = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(IMPERSONATION_STORAGE_KEY);
  emitImpersonationChanged();
};

export const clearCurrentAuthSession = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};
